<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-app-bar dark color="primary">
            <v-toolbar-title>{{ $t("auth.forgot.reset_pass") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text>
            <v-form ref="form">
              <v-flex xs12>
                <v-text-field
                  data-vv-name="new_password"
                  prepend-icon="lock"
                  v-model="new_password"
                  class="required-field"
                  v-validate="'required|password_strength'"
                  :label="$t('auth.new_password')"
                  :error-messages="errors.collect('new_password')"
                  type="password"
                  ref="new_password"
                  :hint="$t('global.helptext_password')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  data-vv-name="new_password_retype"
                  data-vv-as="new_password"
                  prepend-icon="lock"
                  v-model="new_password_retype"
                  class="required-field"
                  v-validate="'required|confirmed:new_password|password_strength'"
                  :label="$t('auth.new_password_retype')"
                  :error-messages="errors.collect('new_password_retype')"
                  type="password"
                  :hint="$t('global.helptext_password')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>

            <action-button type="default" :text="$t('auth.update_password')" @click="update" :icon_only_xs="false" />
            <action-button type="cancel" @click="cancel" :icon_only_xs="false" />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "ForgotResetPassword",

  props: ["token", "locale"],

  data() {
    return {
      new_password: "",
      new_password_retype: "",
      dictionary: {
        attributes: {
          new_password: this.$t("auth.new_password"),
          new_password_retype: this.$t("auth.new_password_retype")
        }
      }
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  created() {
    let vm = this

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    this.validateToken()
  },

  methods: {
    validateToken() {
      let vm = this

      axios
        .post(this.API_URL + "auth/forgotpassword/validate", {
          token: vm.token
        })
        .then((res) => {
          let status = res.data.status

          if (status == "valid-token") {
          } else if (status == "expired-token") {
            vm.$awn.alert(vm.$t("auth.forgot.expired_token"))
            vm.$router.push("/auth/" + this.locale + "/login")
          } else if (status == "invalid-token") {
            vm.$awn.alert(vm.$t("auth.forgot.invalid_token"))
            vm.$router.push("/auth/" + this.locale + "/login")
          }
        })
        .catch((err) => console.log(err))
    },
    update() {
      let vm = this

      this.$validator.validate()

      this.$validator.validateAll().then(() => {
        if (this.isFormValid) {
          axios
            .post(this.API_URL + "auth/forgotpassword/reset", {
              token: vm.token,
              password: vm.new_password
            })
            .then((res) => {
              let status = res.data.status
              let email = res.data.email

              if (status == "reset-ok") {
                vm.$awn.success(vm.$t("auth.forgot.reset_success_m"))
              } else if (status == "reset-failed") {
                vm.$awn.alert(vm.email + vm.$t("auth.forgot.reset_error_m"))
              } else if (status == "invalid-token") {
                vm.$awn.alert(vm.email + vm.$t("auth.forgot.invalid_token"))
              }

              vm.$router.push("/auth/" + this.locale + "/login")
            })
            .catch((err) => console.log(err))
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },
    cancel() {
      this.$router.push("/auth/" + this.locale + "/login")
    }
  }
}
</script>
